import { render, staticRenderFns } from "./EarnPoint.vue?vue&type=template&id=5c9f8bdc&scoped=true&"
import script from "./EarnPoint.vue?vue&type=script&lang=js&"
export * from "./EarnPoint.vue?vue&type=script&lang=js&"
import style0 from "./EarnPoint.vue?vue&type=style&index=0&id=5c9f8bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f8bdc",
  null
  
)

export default component.exports